import * as React from "react"

export interface InputProps extends Omit<
  React.ComponentProps<"input">,
  "size"
> {
  /**
   * Whether to select all text when the input is focused.
   * Defaults to true for number inputs, false for other types.
   * Set explicitly to override the default behavior.
   */
  selectTextOnFocus?: boolean
}

function Input({
  className,
  type,
  selectTextOnFocus,
  onFocus,
  ...props
}: InputProps) {
  const shouldSelectOnFocus =
    selectTextOnFocus ?? (type === "number" ? true : false)

  function handleFocus(e: React.FocusEvent<HTMLInputElement>) {
    if (shouldSelectOnFocus) {
      // Use setTimeout to ensure selection happens after browser's cursor positioning
      setTimeout(() => {
        e.target.select()
      }, 0)
    }
    onFocus?.(e)
  }

  return (
    <input type={type} className={className} onFocus={handleFocus} {...props} />
  )
}
Input.displayName = "Input"

export { Input }
